import {apiGet} from './index'
// 查询学习旅程
const getJourneys = (params) => apiGet('/api/journeys', params)
// 查询旅程阶段
const getJourneysStages = (params) => apiGet('/api/journey/stages', params)
// 查询资料库课程
const getDatabaseCoursesList = (params) => apiGet('/api/courses/selectDataBanklistPage', params)
const getCategoriesApi = () => apiGet('/api/course/categories/tree/framework')
const getCoursesListPage = (params) => apiGet('/api/courses/framework/page', params)
export {
  getCoursesListPage,
  getCategoriesApi,
  getJourneys,
  getJourneysStages,
  getDatabaseCoursesList,
}



// WEBPACK FOOTER //
// ./src/api/database.js